import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-kits/new/loading';

export const Route = createFileRoute('/_private/settings/inventory-kits/new')({
  component: Loading,
});
